import * as React from 'react';

const CircleSlash24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M11.9995 2C17.5223 2 21.9994 6.47727 21.9995 12C21.9995 17.5228 17.5224 22 11.9995 22C6.4769 21.9997 1.99953 17.5227 1.99953 12C1.99967 6.47743 6.47698 2.00025 11.9995 2ZM6.62062 18.582C8.08574 19.7808 9.95882 20.4999 11.9995 20.5C16.6939 20.5 20.4995 16.6944 20.4995 12C20.4995 9.95922 19.7804 8.08626 18.5816 6.62109L6.62062 18.582ZM11.9995 3.5C7.30541 3.50025 3.49967 7.30586 3.49953 12C3.49953 14.1134 4.27093 16.0472 5.54738 17.5342L17.5337 5.54785C16.0467 4.27141 14.1129 3.5 11.9995 3.5Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export default CircleSlash24;
